
import cookie from '@/utils/cookie'

const getters = {
  language: state => {
    if (state.app.language) {
      return state.app.language
    } else {
      return cookie.getCookie(cookie.language_cookie)
    }
  },
  userid: state => {
    if (state.user.userid) {
      return state.user.userid
    } else {
      return cookie.getCookie(cookie.userid_cookie)
    }
  },
  username: state => {
    if (state.user.username) {
      return state.user.username
    } else {
      return cookie.getCookie(cookie.username_cookie)
    }
  },
  factoryid: state => {
    if (state.user.factoryid) {
      return state.user.factoryid
    } else {
      return cookie.getCookie(cookie.factoryid_cookie)
    }
  },
  lineid: state => {
    if (state.user.lineid) {
      return state.user.lineid
    } else {
      return cookie.getCookie(cookie.lineid_cookie)
    }
  },
  clientname: state => {
    if (state.user.clientname) {
      return state.user.clientname
    } else {
      return cookie.getCookie(cookie.clientname_cookie)
    }
  },
  menulist: state => state.app.menulist,
  sidebar: state => state.app.sidebar,
  size: state => state.app.size,
  device: state => state.app.device,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  introduction: state => state.user.introduction,
  roles: state => state.user.roles,
  permission_routes: state => state.permission.routes,
  errorLogs: state => state.errorLog.logs
}
export default getters




// WEBPACK FOOTER //
// ./src/store/getters.js